import { NgModule, Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml'
})
export class SafeHtmlPipe {
    constructor(private readonly sanitizer: DomSanitizer) {

    }

    transform(html: string) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}

@NgModule({
    declarations: [SafeHtmlPipe],
    exports: [SafeHtmlPipe]
})
export class SafeHtmlPipeModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/pipes/safehtml.pipe/safe.html.pipe.module.ts